import React from "react";
import { Autocomplete, TextField } from "@mui/material";

export interface DaiCustomSelectOption {
  label: string;
  value: string;
}

interface DaiCustomSelectDropdownProps {
  options: DaiCustomSelectOption[];
  value: string;
  handleChange: (event: { target: { value: string } }) => void;
  noSelectionLabel?: string;
}

// Drop-in replacement for the old native <select>-based dropdown, backed by MUI Autocomplete.
export default function DaiCustomSelectDropdown({ options, value, handleChange, noSelectionLabel }: DaiCustomSelectDropdownProps) {
  const selected = options.find((o) => o.value === value) ?? undefined;

  return (
    <Autocomplete
      disableClearable
      options={options}
      getOptionLabel={(o) => o.label}
      isOptionEqualToValue={(o, v) => o.value === v.value}
      value={selected}
      onChange={(_event, newValue) => handleChange({ target: { value: newValue ? newValue.value : "" } })}
      renderInput={(params) => <TextField {...params} placeholder={noSelectionLabel} size="small" />}
      sx={{ minWidth: 180 }}
    />
  );
}
